import { call, put, takeEvery } from 'redux-saga/effects';
import { CHANGE_USER_PHONE_REQUEST } from '../../constants/user_phones.constants';
import { changeUserPhone } from '../../../requests/user_phones_requests/change_user_phone_request';
import { changeUserPhoneRequestSuccess, changeUserPhoneRequestFailure } from '../../actions/user_phones_actions/change_user_phone.actions';
import { message_success, message_error } from '../../../../../../components/Message';

function* changeUserPhoneRequest({
    name, phone, user_id, phone_id,
}) {
    const { result, options, msg } = yield call(changeUserPhone, user_id, name, phone, phone_id);
    if (result) {
        yield put(changeUserPhoneRequestSuccess(options.person.phones));
        message_success('Phone changed successfully!');
    } else {
        yield put(changeUserPhoneRequestFailure(msg));
        message_error(msg);
    }
}

export default function* changeUserPhoneSaga() {
    yield takeEvery(CHANGE_USER_PHONE_REQUEST, changeUserPhoneRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_phones_sagas/change_user_phone.saga.js